<div class="content">
  <div class="dresses">
    <app-hover-mask [categoryId]="1" title="Dresses"></app-hover-mask>
  </div>
  <div class="right">
    <div class="tops">
      <app-hover-mask [categoryId]="2" title="Tops"></app-hover-mask>
    </div>
    <div class="more">
      <app-hover-mask
        [categoryId]="0"
        title="Designs in Progress"
      ></app-hover-mask>
    </div>
  </div>
</div>
